import { EntityType } from '@frontend/common';
import { PinCodeClient } from '@frontend/pin-code/api';
import { CreatePinCode, PinCode, PinCodeRendering, PinCodeType } from '@frontend/pin-code/types';
import { FormattedMessage } from 'react-intl';

import CreateModal from '../../../../modal/create-modal/create-modal.component';
import { useCreateMasterPinCodeModal } from './create-master-pin-code-modal.controller';

export interface CreateMasterPinCodeModalProps {
    entity_id: string;
    callback?: (pinCode: PinCode) => void;
}

export const CreateMasterPinCodeModal = (props: CreateMasterPinCodeModalProps) => {
    const viewProps = useCreateMasterPinCodeModal();
    return (
        <CreateModal<PinCode, CreatePinCode>
            order={['code']}
            label={
                <FormattedMessage
                    id='APPLICATIONS.RAKINDA.CREATE_MASTER_PIN_CODE'
                    defaultMessage='Create Master PIN-code'
                />
            }
            type={EntityType.IOT}
            styles={{ body: 'rounded-xl' }}
            required={['code']}
            expectedType={new Map([['code', 'number']])}
            fieldProps={() => new Map([['code', { maxLength: 4 }]])}
            onSubmit={async (value) => {
                try {
                    const pinCode = await PinCodeClient.postPinCode(viewProps.currentAccount, {
                        ...value,
                        code: value.code!.toString(),
                        rendering: PinCodeRendering.TEXT,
                        entity_id: props.entity_id,
                        entity_type: EntityType.IOT,
                        type: PinCodeType.MASTER
                    });
                    props.callback && props.callback(pinCode);
                    return pinCode;
                } catch (error) {
                    return Promise.reject(error);
                }
            }}
        />
    );
};
